import React from 'react';
import { FlaskConical, ShieldCheck, Zap, AlertTriangle, ExternalLink } from 'lucide-react';

export default function LaunchpadAbout() {
  return (
    <div className="max-w-4xl mx-auto space-y-12 animate-in slide-in-from-bottom-8 duration-700">
      <div className="text-center space-y-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 rounded-full border border-emerald-500/20 text-emerald-400 font-bungee text-[10px] uppercase tracking-widest">
          <FlaskConical size={14} />
          <span>Labs Program</span>
        </div>
        <h2 className="text-5xl md:text-6xl font-bungee text-emerald-400 uppercase tracking-tighter leading-none">ABOUT LAUNCHPAD</h2>
        <p className="text-zinc-500 font-bungee text-sm uppercase tracking-widest">Transparency & Experimentation</p>
      </div>

      <div className="bg-zinc-900/50 border-4 border-emerald-500/10 rounded-[3rem] p-10 md:p-16 space-y-12">
        <section className="space-y-6">
          <h3 className="text-3xl font-bungee text-white uppercase tracking-tight border-l-4 border-emerald-500 pl-6">The Vision</h3>
          <p className="text-zinc-400 font-bungee text-sm leading-relaxed">
            BrainRotBlast is an AI meme image generator. We've seen thousands of incredible memes created by our community. 
            Launchpad is our experimental "Labs" program where we explore the intersection of AI-generated memes and decentralized finance.
          </p>
          <p className="text-zinc-400 font-bungee text-sm leading-relaxed">
            Our goal is to create a transparent, fair, and fun way to launch tokens based on the most viral memes from our platform.
          </p>
        </section>

        <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="p-8 bg-black/40 rounded-[2rem] border border-emerald-500/10 space-y-4">
            <div className="p-3 bg-emerald-500/10 rounded-xl border border-emerald-500/20 w-fit">
              <ShieldCheck size={24} className="text-emerald-400" />
            </div>
            <h4 className="text-xl font-bungee text-white uppercase">Transparency</h4>
            <p className="text-xs text-zinc-500 font-bungee leading-relaxed">
              Every launch includes public tokenomics, public founder wallets, and published sell policies. No hidden allocations.
            </p>
          </div>
          <div className="p-8 bg-black/40 rounded-[2rem] border border-emerald-500/10 space-y-4">
            <div className="p-3 bg-emerald-500/10 rounded-xl border border-emerald-500/20 w-fit">
              <Zap size={24} className="text-emerald-400" />
            </div>
            <h4 className="text-xl font-bungee text-white uppercase">Speed</h4>
            <p className="text-xs text-zinc-500 font-bungee leading-relaxed">
              We move fast. From viral meme to live token in hours, powered by our community's creativity.
            </p>
          </div>
        </section>

        <section className="p-8 bg-emerald-500/5 border-2 border-emerald-500/20 rounded-[2rem] space-y-6">
          <div className="flex items-center gap-3 text-emerald-400">
            <AlertTriangle size={24} />
            <h4 className="text-xl font-bungee uppercase">Experimental Nature</h4>
          </div>
          <p className="text-xs text-emerald-100/60 font-bungee leading-relaxed">
            Launchpad is a separate Labs project. It is not the core BrainRotBlast product. 
            Participation in these experiments involves extreme risk. There are no promises of financial return. 
            Tokens launched here are for entertainment and research purposes only.
          </p>
          <div className="pt-4">
            <button className="px-6 py-3 bg-emerald-500 text-black rounded-xl font-bungee text-xs uppercase shadow-lg hover:scale-105 transition-all">
              I Understand the Risks
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
